import React, { useEffect, useState } from "react";
import "./Ordered.css";
import Order_Details_Card from "../order_details_card/Order_Details_Card";
import Common_Back_Header from "../../../../common/common_components/common_back_header/Common_Back_Header";
import { getAllOrder } from "../../../../../features/order/orderSlice";
import { useDispatch, useSelector } from "react-redux";
import { encodeId } from "../../../../../utils/common";

const Ordered = () => {
  const [showCouponModal, setShowCouponModal] = useState(false);

  const data = [
    {
      order_id: 75843,
      item_no: 1,
      price: 1200,
      date: "13th May | 03:28 pm",
      subtext: "Delivering in 10 mins",
    },
  ];

  const dispatch = useDispatch();
  const orders = useSelector((state) => state.order.allOrders);
  useEffect(() => {
    dispatch(getAllOrder({ order_status_id: [1, 2, 3, 4] }));
  }, [dispatch]);

  // console.log({ orders });


  return (
    <>
      <section className="Ordered">
        {orders?.data?.map((item) => {
          return (
            <Order_Details_Card
              orderId={item?.invoice_no || " "}
              no_of_items={item?.no_of_item || "0"}
              date={item?.createdAt || new Date()}
              data={item}
              price={item?.total_amount || "0"}
              subtext={item?.Order_status?.name || "Pending"}
              onClick={() => {
                setShowCouponModal(true);
              }}
              // baseLike={`/order-details`}
              baseLike={`/order-details/${encodeId(item?.id)}`}
            />
          );
        })}

        <div className="no_data_main_div">
          <p className="no_data_text">No more orders to show</p>
        </div>
      </section>

      {/* <OrderTrackModal
        show={showCouponModal}
        onHide={() => { setShowCouponModal(false) }}
      /> */}
    </>
  );
};

export default Ordered;
